export function siteIntersectionObserver(){
    document.querySelectorAll('.wag-dot, .square-image, .image-content-block, .download-block, .testimonial-block').forEach((item) => {
        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {

                if (entry.intersectionRatio === 1 ) {
                    if(item.classList.contains('wag-dot')) {
                        item.classList.add('after:animate-dot')
                    }else if(item.classList.contains('testimonial-block')) {
                        item.querySelector('span.highlighed_testimonial').classList.add('show')
                    }else{
                        if(item.querySelector('img:not(.injectable)')) {
                            item.querySelector('img:not(.injectable)').classList.add('animate-zoom')
                        }
                    }
                }

            });
        }, {
            threshold: [0, .25, .5, .75, 1]
        });

        observer.observe(item)
    })
}